import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Go2Logo from 'assets/images/path-header.svg';
import { Logo } from './Headline.styles';
import M3Card from 'components/M3/M3Card';

type HeadlineProps = {};

const Headline: React.FC<HeadlineProps> = () => {
  return (
    <Grid
      container
      maxWidth={{
        xs: '370px',
        sm: '750px',
        md: '1000px',
        lg: '1400px',
        xl: '1600px',
      }}
    >
      <M3Card
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: {
            xs: 'column-reverse',
            sm: 'row',
          },
          alignItems: 'center',
          bgcolor: '#D5E3FF',
          m: {
            xs: 1,
            sm: 2,
          },
          py: 3,
          borderRadius: '24px',
        }}
        noHover
      >
        <Grid item xs={12} sm={6} md={8}>
          <Box
            display='flex'
            flexDirection='column'
            alignItems={{
              xs: 'center',
              sm: 'flex-start',
            }}
            justifyContent='center'
            pl={{
              xs: 0,
              sm: 10,
            }}
            px={{
              xs: 2,
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: { xs: '30px', sm: '35px', md: '70px', lg: '100px' },
                lineHeight: { sm: '40px', md: '80px', lg: '116px' },
                fontWeight: 600,
              }}
              mt={{
                xs: 2,
                sm: 0,
              }}
              variant='h1'
            >
              Welcome to Path!
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '20px', sm: '18px', md: '30px', lg: '48px' },
                fontWeight: 600,
                lineHeight: { sm: '30px', md: '80px', lg: '116px' },
                mt: 2,
              }}
              variant='h3'
            >
              Your Go2 Career Building tool.
            </Typography>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 400,
                maxWidth: { md: '340px', lg: '601px' },
                mt: {
                  xs: 2,
                  sm: 3,
                  md: 0,
                },
                textAlign: {
                  xs: 'center',
                  sm: 'left',
                },
              }}
              variant='subtitle2'
            >
              Navigating your career shouldn't feel like a maze filled with
              dead-ends. It’s time to take control of your trajectory. Meet Your
              new coworker Path, they provide tailored insights into your work
              habits and growth areas, setting you on a path (get it?) to being
              in control of your career.
            </Typography>
            <Typography
              fontSize={18}
              sx={{
                pt: 2,
                fontWeight: 500,
                maxWidth: {
                  md: '340px',
                  lg: '640px',
                },
                textAlign: {
                  xs: 'center',
                  sm: 'left',
                },
              }}
            >
              Increase the value of your three most important assets: your
              skills, your time, and your data.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            ml={{
              sm: 0,
              md: -15,
              lg: -20,
            }}
          >
            <Logo alt='Go2' src={Go2Logo} />
          </Box>
        </Grid>
      </M3Card>
    </Grid>
  );
};

export default Headline;
